import {StyleProp, ViewStyle} from 'react-native';
import {BaseFieldProps} from '../../../../../../../shared/components/baseField';
import View from './view';

export const CheckboxField = (props: BaseFieldProps & {style?: StyleProp<ViewStyle>}) => {
  const isChecked = !!props.input.value;
  const onPress = () => {
    if (props.input.onChange) {
      props.input.onChange(!isChecked);
    }
  };
  return View({
    name: props.name,
    label: props.label,
    isChecked,
    onPress,
    style: props.style,
  });
};
